import React, { useState } from "react";
import { API_BASE_URL } from "../../API/endpoint";

export const ProductForm = ({ product, categories, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    title: product.title || "",
    price: product.price || "",
    description: product.description || "",
    categoryId: product.category?.id || "",
    image: null,
    id: product.id,
  });
  const [imagePreview, setImagePreview] = useState(
    product.path ? `${API_BASE_URL}${product.path}` : null
  );

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, image: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = new FormData();
    dataToSend.append("title", formData.title);
    dataToSend.append("price", formData.price);
    dataToSend.append("description", formData.description);
    dataToSend.append("categoryId", formData.categoryId);
    if (formData.image) {
      dataToSend.append("image", formData.image);
    }
    if (formData.id) {
      dataToSend.append("id", formData.id);
    }
    onSave(dataToSend);
  };

  return (
    <div className="admin-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Titre</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Prix (€)</label>
          <input
            type="number"
            value={formData.price}
            onChange={(e) =>
              setFormData({ ...formData, price: Number(e.target.value) })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Image du produit</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {imagePreview && (
            <div style={{ marginTop: "10px" }}>
              <img
                src={imagePreview}
                alt="Aperçu"
                style={{
                  maxWidth: "200px",
                  maxHeight: "200px",
                  objectFit: "contain",
                  border: "1px solid #ddd",
                  padding: "5px",
                }}
              />
            </div>
          )}
        </div>
        <div className="form-group">
          <label>Catégorie</label>
          <select
            value={formData.categoryId}
            onChange={(e) =>
              setFormData({ ...formData, categoryId: e.target.value })
            }
            required
          >
            <option value="">Sélectionner une catégorie</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-save">
            Enregistrer
          </button>
          <button type="button" className="btn-cancel" onClick={onCancel}>
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};
